import { gql } from "@apollo/client";

export const GET_PLUGCHAT_STATUS = gql`
  query GetPlugchatStatus {
    plugchatStatus {
      plugchatConnected
      plugchatQrCode
      connectedNumber
    }
  }
`;

export const DISCONNECT_PLUGCHAT = gql`
  mutation DisconnectPlugchat {
    disconnectPlugchat(input: {}) {
      success
    }
  }
`;

export const GET_EVOLUTION_STATUS = gql`
  query GetEvolutionStatus {
    evolutionStatus {
      evolutionConnected
      evolutionQrCode
      connectedNumber
    }
  }
`;

export const DISCONNECT_EVOLUTION = gql`
  mutation DisconnectEvolution {
    disconnectEvolution(input: {}) {
      success
    }
  }
`;

export const GET_ACCOUNT = gql`
  query GetAccount {
    account {
      id
      name
      corporateName
      email
      document
      phone
      domain
      initialCode
      currentCode
      uniqueDocument
      plugchatToken
      plugchatConnected
      plugchatQrCode
      searchLimit
      searchPartial
      anyWord
      tokenPipedrive
      pipedriveStageId
      instantSearch
      aiPromptTemplate
      campaignOfferPromptTemplate
      campaignReactivationPromptTemplate
      campaignActivationPromptTemplate
      campaignFollowUpPromptTemplate
      priceSegmentationId
      inactiveCustomerDays
      businessType
      servicePromptTemplate
      campaignThrottlingEnabled
      campaignMinIntervalSeconds
      campaignMaxIntervalSeconds
      dailyMessageLimit
      dailyMessagesRemaining
      whatsappIaServiceEnabled
      campaignHours
      onlyVerifiedWhatsappCampaigns
      whatsappProvider
      address {
        id
        street
        number
        description
        room
        complement
        district
        zipcode
        cityId
        city {
          id
          name
          state {
            id
            initials
          }
        }
      }
    }
  }
`;

export const UPDATE_ACCOUNT = gql`
  mutation StoreAccount($attributes: AccountAttributes!) {
    storeAccount(input: {attributes: $attributes}) {
      account {
        id
        name
        phone
        domain
        initialCode
        email
        document
        corporateName
        uniqueDocument
        plugchatToken
        currentCode
        searchLimit
        searchPartial
        anyWord
        instantSearch
        aiPromptTemplate
        campaignOfferPromptTemplate
        campaignReactivationPromptTemplate
        campaignActivationPromptTemplate
        campaignFollowUpPromptTemplate
        priceSegmentationId
        inactiveCustomerDays
        businessType
        servicePromptTemplate
        tokenPipedrive
        pipedriveStageId
        pipedriveUsername
        pipedrivePassword
        campaignThrottlingEnabled
        campaignMinIntervalSeconds
        campaignMaxIntervalSeconds
        dailyMessageLimit
        whatsappIaServiceEnabled
        messagesSentToday
        messagesScheduledForToday
        dailyMessagesRemaining
        campaignHours
        onlyVerifiedWhatsappCampaigns
        address {
          id
          number
          street
          description
          room
          zipcode
          district
          complement
          cityId
          city{
            id
          }
        }
      }
      errors
    }
  }
`;

export const UPDATE_CAMPAIGN_HOURS = gql`
  mutation UpdateCampaignHours($campaignHours: JSON!) {
    updateCampaignHours(input: {campaignHours: $campaignHours}) {
      account {
        id
        campaignHours
      }
      errors
    }
  }
`;

export const GENERATE_PIPEDRIVE_CREDENTIALS = gql`
  mutation GeneratePipedriveCredentials($accountId: ID!) {
    generatePipedriveCredentials(input: { accountId: $accountId }) {
      account {
        id
        pipedriveUsername
        pipedrivePassword
      }
      errors
    }
  }
`;

export const START_WHATSAPP_MASS_VERIFICATION = gql`
  mutation StartWhatsappMassVerification {
    startWhatsappMassVerification {
      jobId
      status
      estimatedCount
      errors
    }
  }
`;

export const GET_WHATSAPP_VERIFICATION_JOB_STATUS = gql`
  query GetWhatsappVerificationJobStatus($jobId: ID!) {
    whatsappVerificationJobStatus(jobId: $jobId) {
      id
      status
      progress
      totalCount
      processedCount
      successCount
      failureCount
      startedAt
      completedAt
    }
  }
`;
export const GET_AI_PROMPT_QUESTIONS = gql`
  query GetAiPromptQuestions($referenceField: String!) {
    aiPromptQuestions(referenceField: $referenceField) {
      id
      question
      referenceField
      campaignKind
      position
      answer {
        id
        answer
      }
    }
  }
`;

export const SAVE_AI_PROMPT_QUESTION_ANSWER = gql`
  mutation SaveAiPromptQuestionAnswer($questionId: ID!, $answer: String!) {
    saveAiPromptQuestionAnswer(input: { questionId: $questionId, answer: $answer }) {
      answer {
        id
        answer
        aiPromptQuestionId
      }
      errors
    }
  }
`;

export const GENERATE_ACCOUNT_PROMPT_TEMPLATE = gql`
  mutation GenerateAccountPromptTemplate($referenceField: String!) {
    generateAccountPromptTemplate(input: { referenceField: $referenceField }) {
      promptTemplate
      account {
        id
        aiPromptTemplate
        campaignOfferPromptTemplate
        campaignReactivationPromptTemplate
        campaignActivationPromptTemplate
        campaignFollowUpPromptTemplate
        servicePromptTemplate
      }
      errors
    }
  }
`;
